/**
 * @description 判斷檔案是否為圖片檔案格式
 *
 * @param extension 檔案副檔名，接受 .gif 或 gif
 * @returns 是否為圖片檔案格式
 */
export function isImageFileExtension(extension: string): boolean {
  const imageFileExtensions = ['.gif', '.jpg', '.jpeg', '.png'];
  return imageFileExtensions.some(
    (item) => item.indexOf(extension.trim().toLocaleLowerCase()) > -1
  );
}
